import { createSelector } from 'reselect';
import { playerStatsSelector } from './simple-selectors';

export const playerStatsModalSelector = createSelector(
    playerStatsSelector,
    (playerStats) => playerStats.modal
);
